import React from "react"
import { useTranslation } from "react-i18next"
import { List, ListItem, Button, styled } from "@mui/material"

import { useAppDispatch } from "redux/hooks"
import { showAlert } from "redux/features/notice/noticeSlice"
import { colors } from "theme"

interface ProviderItemType {
  path: string
  title: string
}

type Props = {
  light?: boolean
  items: ProviderItemType[]
  disabled: boolean
  onClick: (path: string) => void
}

const ProvidersListComponent = styled(
  ({ light, items, disabled, onClick }: Props) => {
    const dispatch = useAppDispatch()
    const { t } = useTranslation()

    const handleClick = (item: ProviderItemType) => {
      if (disabled) {
        dispatch(
          showAlert({
            message: t("notice.sessions.consent.required"),
          }),
        )

        return
      } else {
        const { path } = item

        if (path) {
          onClick(path)
        } else {
          return
        }
      }
    }

    return (
      <ProvidersList>
        {items.map((item: ProviderItemType, index: number) => (
          <ListItemProvider key={index}>
            <ListItemProviderButton
              disableElevation
              disableRipple
              disableFocusRipple
              sx={{
                backgroundColor: light ? colors.white : colors.ghostWhite,
              }}
              onClick={() => handleClick(item)}
            >
              {item.title}
            </ListItemProviderButton>
          </ListItemProvider>
        ))}
      </ProvidersList>
    )
  },
)(() => ({}))

export default ProvidersListComponent

ProvidersListComponent.defaultProps = {
  light: false,
  disabled: false,
}

const ProvidersList = styled(List)(({ theme }) => ({
  display: "flex",
  [theme.breakpoints.up("lg")]: {
    flexDirection: "column",
    width: "100%",
  },
  [theme.breakpoints.down("lg")]: {
    background: "rgba(0, 169, 149, 0.11)",
    borderRadius: "64px",
    flexDirection: "row",
    padding: "4px",
  },
  [theme.breakpoints.down("md")]: {
    overflowY: "scroll",
  },
}))

const ListItemProvider = styled(ListItem)(({ theme }) => ({
  padding: "0 16px",
  [theme.breakpoints.down("lg")]: {
    padding: "0",
    margin: "0",
  },
}))

const ListItemProviderButton = styled(Button)(({ theme }) => ({
  color: colors.maastrichtBlue,
  borderRadius: "17px",
  fontSize: "18px",
  fontWeight: "500",
  justifyContent: "flex-start",
  lineHeight: "22px",
  margin: "6px 0",
  padding: "40px 50px",
  textTransform: "initial",
  width: "100%",
  [theme.breakpoints.down("lg")]: {
    backgroundColor: "transparent",
    fontWeight: "600",
    fontSize: "12px",
    margin: "0",
    padding: "8px 0",
    justifyContent: "center",
  },
}))
